import React from 'react';
import styles from './UserContent.module.scss';

export interface UserContentProps {
    /**
     * The full name of the user
     */
    fullName: string;
    /**
     * The email of the user
     */
    email: string;
}

export const UserContent = ({ fullName, email }: UserContentProps) => (
    <div data-testid="user-content">
        <h4 className={styles.ui800TextColor}>{fullName}</h4>
        <div className={styles.maxTruncate}>
            <p className={styles.textRendering}>{email}</p>
        </div>
    </div>
);
